import React from 'react';

export interface IconErrorProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconError: React.FC<IconErrorProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 81 80"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <rect x="0.5" width="80" height="80" rx="40" fill={fill || "#FBCFE8"} /> <g clipPath="url(#clip0_4676_56013)"> <path d="M40.5001 58.3334C50.6253 58.3334 58.8334 50.1252 58.8334 40C58.8334 29.8748 50.6253 21.6667 40.5001 21.6667C30.3749 21.6667 22.1667 29.8748 22.1667 40C22.1667 50.1252 30.3749 58.3334 40.5001 58.3334Z" stroke={stroke || "#BE185D"}  strokeWidth="1.5" strokeMiterlimit="10" /> <path d="M40.5 32.6667V40" stroke={stroke || "#BE185D"}  strokeWidth="1.5" strokeLinecap="square" /> <path d="M40.5 45.6833V45.5" stroke={stroke || "#BE185D"}  strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" /> </g> <defs> <clipPath id="clip0_4676_56013"> <rect width="44" height="44" fill={fill || "white"}  transform="translate(18.5 18)" /> </clipPath> </defs>  
    </svg>
  );
};

export default IconError;
